<template>
	<div class="main-content">
		<Nav></Nav>
		<div class="center-body">
			<Breadcrumb separator=">" style="line-height: 45px;padding-left: 10px;margin-top: 20px;">
		        <BreadcrumbItem to="/product">产品</BreadcrumbItem>
		        <BreadcrumbItem >产品详情</BreadcrumbItem>
		    </Breadcrumb>
		    
		    <div class="row main">
		    	<div class="col" style="padding-left: 10px;margin-right: 75px;margin-top: 30px;">
		    		<div class="row detail-tit" style="align-items: center;color: #123466;">
				    	<img src="../../assets/img/pr1.png" style="width: 24px;height: 20px;margin-right: 5px;">技术说明：
				    </div>
		    		<div v-html="product.text1" style="line-height: 2;">{{product.text1}}</div>
		    		<div class="row detail-tit" style="align-items: center;color: #123466;margin-top: 40px;">
				    	<img src="../../assets/img/pr2.png" style="width: 20px;height: 20px;margin-right: 5px;">优势特征：
				    </div>
				    <div v-html="product.text2" style="line-height: 2;">{{product.text2}}</div>
		    	</div>
		    	<div class="item-no" style="align-items: flex-start;margin-top: 40px;">
		    		<img :src="require(`../../assets/img/${product.src}`)" class="detail-img"/>
		    	</div>
		    </div>
		    <div class="phone">
		    	<div class="row " >
			    	<img :src="require(`../../assets/img/${product.src}`)" class="detail-img"/>		    	
			    </div>

	    		<div class="row detail-tit" style="padding: 15px 15px;color: #123466;">
			    	<img src="../../assets/img/pr1.png" style="width: 24px;height: 20px;margin-right: 5px;">技术说明：
			    </div>
	    		<div v-html="product.text1" style="padding: 0px 15px;line-height: 2;">{{product.text1}}</div>
	    		<div class="row detail-tit" style="padding: 15px 15px;color: #123466;">
			    	<img src="../../assets/img/pr2.png" style="width: 20px;height: 20px;margin-right: 5px;">优势特征：
			    </div>
			    <div v-html="product.text2" style="padding: 0px 15px;line-height: 2;">{{product.text2}}</div>
		    </div>
		    
		</div>	
	</div>
</template>

<script>
	import Nav from './nav.vue'
	export default {
		name: 'App',
		components: {
		    Nav
		},
		data() {
			return {
				index:0,
				productList:[
				{
					text1:'1、吨袋落入全密封式吨袋卸料系统；<br>2、物料经多螺旋精确计量喂料机计量后，由风机送至加药点。<br>',
					text2:'1、全封闭式，防止物料外泄飞散；<br>2、不引入其它介质，纯物料即时投加，可靠性高；<br>3、一套系统可配多个出药口，配置灵活多变；<br>4、精确计量精准投加，闭环控制；<br>5、全自动化设计，一键式操作，故障自诊切换，无人值守；<br>6、定制化设计，根据现场空间、实际物料投加需求量身定做。<br> ',
					src:'p1.jpg'
				},
				{
					text1:'1、料袋中物料经真空上料机吸入储料斗待用；<br>2、物料经多螺旋精确计量喂料机计量，初步溶解后物料由水射器送入后续配制罐。<br> ',
					text2:'1、全封闭式，防止物料受潮结块；<br>2、精确计量喂料机与储料斗直连，无阻碍自由出料；<br>3、精确计量精准投加，闭环控制；<br>4、全自动化设计，一键式操作，故障自诊切换，无人值守；<br>5、定制化设计，根据现场空间、实际物料投加需求量身定做。<br> ',
					src:'p3.jpg'
				},
				{
					text1:'1、料袋中物料经真空上料机吸入储料斗待用；<br>2、物料经多螺旋精确计量喂料机计量，初步溶解后由水射器送入制备罐，充分溶解熟化后放入存储罐待用。<br>',
					text2:'1、固液两用配制，一机两用；<br>2、全封闭式系统，防止物料受潮结块；<br>3、物料溶解时间精准可控，达到最佳药效；<br>4、精确计量精准投加，闭环控制；<br>5、全自动化设计，一键式操作，故障自诊切换，无人值守；<br>6、定制化设计，根据现场空间、实际物料投加需求量身定做。<br>  ',
					src:'p5.jpg'
				},{
					text1:'1、吨袋落入全密封式吨袋卸料系统；<br>2、物料经过多螺旋精确计量喂料机计量，初步溶解后由水射器送入制备罐，充分溶解熟化后放入存储罐待用。<br>',
					text2:'1、固液两用配制，一机两用；<br>2、全封闭式系统，防止物料受潮结块；<br>3、物料溶解时间精准可控，达到最佳药效；<br>4、精确计量精准投加，闭环控制；<br>5、全自动化设计，一键式操作，故障自诊切换，无人值守；<br>6、定制化设计，根据现场空间、实际物料投加需求量身定做。<br>  ',
					src:'p7.jpg'
				},{
					text1:'1、吨袋落入全密封式吨袋卸料系统；<br>2、物料经过多螺旋精确计量喂料机计量，再经由长距离螺旋输送器送至制备罐进行充分混合，即配即用。<br>',
					text2:'1、全封闭式，防止物料外泄飞散；<br>2、精确计量精准投加，闭环控制；<br>3、配制浓度精准可控；<br>4、防潮防堵，避免堵塞风险； <br>5、全自动化设计，一键式操作，故障自诊切换，无人值守；<br>6、定制化设计，根据现场空间、实际物料投加需求量身定做。<br> ',
					src:'p9.jpg'
				},{
					text1:'1、物料通过散装槽车车载风机送入储料仓存储待用；<br>2、物料经过多螺旋精确计量喂料机计量，再经由长距离螺旋输送器将物料送至制备罐（沉砂桶）配液；<br>3、制备罐（沉砂桶）中均质悬浊液经溢流进入存储罐，即配即用。<br>',
					text2:'1、全封闭式，防止物料外泄飞散；<br>2、大口径检修隔离阀操作及设计人性化；<br>3、刚性有轴螺旋设计，避免大料仓承压变形；<br>4、精确计量精准投加，独立的多螺旋计量设计，避免不可控的物料回流；<br>5、多螺旋精确计量喂料机调节比大，系统设计适用不同处理量及投加率；<br>6、配制浓度精准可控；<br>7、防潮防堵，避免堵塞风险；<br>8、全自动化设计，一键式操作，故障自诊切换，无人值守；<br>9、定制化设计，根据现场空间、实际物料投加需求量身定做。<br>  ',
					src:'p11.jpg'
				}
				],
				product:{},
			}
		},
		methods: {
			
		},
		mounted() {
			this.index=this.$route.params.id
			this.product=this.productList[this.index]
		}
	}
</script>

<style scoped>
	.main-content {
		min-height: 100%;
		width: 100%;
		display: block;
		position: absolute;
		background: #FFF;
	}
	.detail-tit{
		font-size: 16px;
		font-weight: 600;
		padding: 10px 0px;
	}
	@media screen and (max-width: 980px) {
	    .center-body{	    	
	    	width: 100%;
	    	padding-bottom: 60px;	    	
	    }
	    .main-nav{
	    	display: none;
	    }
	   	.main{
	   		display: none;
	   	}
	   	.detail-img{
	   		width: 100%;
	   	}
	}
	@media screen and (min-width: 980px) {
	    .center-body{	    	
	    	width: 1000px;
	    	margin: 0 auto;
	    	padding-bottom: 60px;
	    }
	    .nav-title{
	    	font-size: 30px;
	    	height: 60px;
	    	padding-top: 10px;
	    	width: 160px;
	    	text-align: center;
	    	border-bottom: 1px solid #dcdee2;
	    	flex: none;
	    	
	    }
	    .nav-right{	    	
	    	height: 60px;
	    	border-bottom: 1px solid #dcdee2;
	    	
	    }
	    .ivu-menu-item{
	    	width: 120px;
	    	text-align: center;
	    }
	    .detail-img{
	    	width: 500px;
	    }
	    .phone{
	    	display: none;
	    }
	  
	}
</style>